import React from 'react';
import styled from 'styled-components';
import { StyledLogo, StyledLogoProps } from './Logo.styled';

export const LogoBig = (props: StyledLogoBigProps) => (
  <StyledLogoBig {...props} viewBox="0 0 146 40">
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor" className="logo-icon">
        <path d="M20.271 11.93h-3.225a.07.07 0 0 0-.07.07v1.664a.07.07 0 0 0 .034.06c.01.007.024.01.036.01a.077.077 0 0 0 .033-.008l3.225-1.664a.07.07 0 0 0 .036-.079.07.07 0 0 0-.069-.053M18.262 16.61l-3.897 1-3.898-1a.075.075 0 0 0-.084.037.073.073 0 0 0 .016.09l3.915 3.416a.074.074 0 0 0 .05.018h.001a.075.075 0 0 0 .05-.018l3.915-3.416a.073.073 0 0 0 .016-.09.075.075 0 0 0-.084-.036M11.783 13.734a.07.07 0 0 0 .037-.01.07.07 0 0 0 .034-.06V12a.07.07 0 0 0-.07-.07H8.557a.07.07 0 0 0-.068.053.07.07 0 0 0 .036.08l3.225 1.663c.01.005.021.008.032.008" />
        <path d="M21.35 18.399a.071.071 0 0 1-.022.034l-1.647 1.43-1.622 3.755-3.771-3.29a.074.074 0 0 0-.05-.019h-.001a.072.072 0 0 0-.05.019l-3.67 3.201-1.683-3.666-1.648-1.43a.07.07 0 0 1-.022-.034l-1.503-5.4a.072.072 0 0 1 .005-.051l3.266-6.36a.071.071 0 0 1 .084-.035l5.122 1.54h.238l5.122-1.54a.071.071 0 0 1 .084.035l3.266 6.36c.008.015.01.033.005.05l-1.504 5.4zm-3.881 6.646a.07.07 0 0 1-.065.043h-6.147a.07.07 0 0 1-.064-.041l-.583-1.27 3.63-2.023 3.748 2.09-.52 1.201zM14.44 0C6.468 0 .005 6.23 0 13.916c.008 5.55 7.562 17.665 11.7 23.84 0 0 1.277 2.022 2.658 2.022s2.65-2.022 2.65-2.022c4.199-6.174 11.866-18.29 11.873-23.84C28.876 6.229 22.413 0 14.441 0z" />
      </g>
      <path fill="#000" d="M29 14.018v.02V14v.018" />
      <path
        fill="currentColor"
        className="logo-text"
        d="M42.85 17.723c-1.26-.142-1.919-.614-2.264-1.077l-.032-.046a2.021 2.021 0 0 1-.067-.102l-.01-.016a1.93 1.93 0 0 1-.223-.544 3.38 3.38 0 0 1-.109-.646c-.114-1.002.316-3.365 2.795-3.365 2.79 0 2.97 2.974 2.97 2.974h4.86c0-7.617-7.38-7.89-7.38-7.89-7.53-.333-8.19 6.798-8.19 6.798-.42 7.616 5.527 8.72 7.08 8.89 1.575.174 5.25.668 4.68 4.552-.57 3.884-3.81 3.824-3.81 3.824-3.99 0-4.32-4.157-4.32-4.157H34c.12 6.675 5.58 8.92 8.7 9.073 3.12.151 9.3-1.51 9.3-9.134 0-7.617-6.45-8.83-9.15-9.134M77 36h5V17h-5zM114.654 31.472a5.048 5.048 0 1 1 0-10.096 5.048 5.048 0 0 1 0 10.096M114.5 17a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M136.424 31.472a5.048 5.048 0 1 1 0-10.096 5.048 5.048 0 0 1 0 10.096M136.5 17a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19M68 17v7.113c.388.714.608 1.53.608 2.395 0 .866-.22 1.68-.608 2.395V36h5V17h-5z"
      />
      <path
        fill="currentColor"
        className="logo-text"
        d="M63.777 31.472c-2.892 0-5.237-2.26-5.237-5.048 0-2.788 2.345-5.048 5.237-5.048 2.893 0 5.238 2.26 5.238 5.048 0 2.788-2.345 5.048-5.238 5.048zM71 19.958A10.003 10.003 0 0 0 63.856 17C58.413 17 54 21.253 54 26.5s4.413 9.5 9.856 9.5c2.813 0 5.348-1.137 7.144-2.958V19.958zM76.91 15H82c0-5.476-4.464-9.922-10-10v5.022c2.72.078 4.91 2.278 4.91 4.978M85 36h5V17h-5z"
      />
      <path
        fill="currentColor"
        className="logo-text"
        d="M89.88 36V25.97c0-2.263 1.849-4.105 4.12-4.105s4.12 1.842 4.12 4.106V36H103V25.97c0-4.954-4.03-8.97-9-8.97s-9 4.016-9 8.97V36h4.88z"
      />
    </g>
  </StyledLogoBig>
);

LogoBig.defaultProps = {
  height: 40
};

type StyledLogoBigProps = StyledLogoProps & { iconColor?: string; textColor?: string };
export const StyledLogoBig = styled(StyledLogo)<StyledLogoBigProps>`
  & .logo-icon {
    color: ${props => props.iconColor};
  }
  & .logo-text {
    color: ${props => props.textColor};
  }
`;
